import { Button } from 'antd';
import React from 'react'
import { useCalendlyEventListener, InlineWidget } from "react-calendly";
import config from '../config';

function Appointments() {
    useCalendlyEventListener({
        onProfilePageViewed: () => console.log("onProfilePageViewed"),
        onDateAndTimeSelected: () => console.log("onDateAndTimeSelected"),
        onEventTypeViewed: () => console.log("onEventTypeViewed"),
        onEventScheduled: (e) => console.log(e.data.payload),
        onPageHeightResize: (e) => console.log(e.data.payload.height),
    });
    return (
        <div>
            <div className='flex justify-end mr-22'>
                <Button
                    type='primary'
                    onClick={() => window.open("https://calendly.com/app/scheduled_events/user/me", "_blank")}
                    className="px-4 py-2 bg-blue-500 text-white rounded-lg"
                >
                    View Scheduled Events
                </Button>
            </div>
            <InlineWidget url={`https://calendly.com/${config.CALENDLY_USERNAME}`} />
        </div>
    )
}

export default Appointments